import { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import Button from "components/AtomsV2/Button";
import Icon from "components/ShellV2/Icon";
import UploadHelpModal from "components/UploadHelpModal";

function UploadHelpButton({ variant, size, className, disabled }) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation(["common"]);

  const openHelp = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen(true);
  };

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={className}
        disabled={disabled}
        onClick={openHelp}
        title={t("uploadHelp.title")}
      >
        <Icon name="help_outline" />
        {t("uploadHelp.button")}
      </Button>
      <UploadHelpModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}

UploadHelpButton.propTypes = {
  variant: PropTypes.oneOf(["primary", "ghost"]),
  size: PropTypes.oneOf(["md", "sm"]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

UploadHelpButton.defaultProps = {
  variant: "ghost",
  size: "sm",
  className: "",
  disabled: false,
};

export default UploadHelpButton;
